import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    updateAndEnableFilter,
    retirementHomeSelector,
    newHomesSelector,
    preOwnedSelector
} from '../../reducers/filters';
import { SometimesInlineFiltersCheckBox } from './Filters.styles';

export const SelectTypeOfHome: FC = () => {
    const reduxDispatch = useDispatch();

    const {
        selectedValue: newHomes,
        label: newHomesLabel,
        disabled: newHomesDisabled
    } = useSelector(newHomesSelector);

    const {
        selectedValue: preOwned,
        label: preOwnedLabel,
        disabled: preOwnedDisabled
    } = useSelector(preOwnedSelector);

    const {
        selectedValue: retirementHome,
        label: retirementHomeLabel,
        disabled: retirementHomeDisabled
    } = useSelector(retirementHomeSelector);

    const onChangeRetirementHome = (evt: ChangeEvent<HTMLInputElement>) => {
        updateAndEnableFilter(
            'retirementHome',
            evt.currentTarget.checked
        )(reduxDispatch);
    };

    const onChangeNewHomes = (evt: ChangeEvent<HTMLInputElement>) => {
        updateAndEnableFilter(
            'newHomes',
            evt.currentTarget.checked
        )(reduxDispatch);
    };

    const onChangePreOwned = (evt: ChangeEvent<HTMLInputElement>) => {
        updateAndEnableFilter(
            'preOwned',
            evt.currentTarget.checked
        )(reduxDispatch);
    };

    return (
        <>
            <SometimesInlineFiltersCheckBox
                label={newHomesLabel}
                id="new-homes"
                data-testid="filters-modal-new-homes"
                checked={newHomes}
                onChange={onChangeNewHomes}
                disabled={newHomesDisabled}
            />
            <SometimesInlineFiltersCheckBox
                label={preOwnedLabel}
                id="pre-owned"
                data-testid="filters-modal-pre-owned"
                checked={preOwned}
                onChange={onChangePreOwned}
                disabled={preOwnedDisabled}
            />
            <SometimesInlineFiltersCheckBox
                label={retirementHomeLabel}
                id="retirement-home"
                data-testid="filters-modal-retirement"
                checked={retirementHome}
                onChange={onChangeRetirementHome}
                disabled={retirementHomeDisabled}
            />
        </>
    );
};
